import { NavLink } from "react-router-dom";
import { CgClose } from "react-icons/cg";

import classes from "./css/MobileNavigation.module.css";

const MobileNavigation = (props) => {
  return (
    <nav className={classes.main}>
      <ul className={classes.list}>
        <li>
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? classes.active : undefined
            }
            onClick={props.onClick}
            end
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? classes.active : undefined
            }
            onClick={props.onClick}
          >
            Chi Sono
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/shows"
            className={({ isActive }) =>
              isActive ? classes.active : undefined
            }
            onClick={props.onClick}
          >
            Spettacoli
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/archive"
            className={({ isActive }) =>
              isActive ? classes.active : undefined
            }
            onClick={props.onClick}
          >
            Archivio
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dionisiache"
            className={({ isActive }) =>
              isActive ? classes.active : undefined
            }
            onClick={props.onClick}
          >
            Dionisiache
          </NavLink>
        </li>
      </ul>
      <CgClose className={classes.menuClose} onClick={props.onClick} />
    </nav>
  );
};

export default MobileNavigation;
